/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PGAModelBuilderCalcTabsGetCalcsQueryVariables = {|
  modelId: string
|};
export type PGAModelBuilderCalcTabsGetCalcsQueryResponse = {|
  +calcFeaturesForPgaTourModel: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
    +calculation: ?{|
      +id: string,
      +name: string,
      +classification: {|
        +id: string,
        +name: string,
      |},
    |},
    +weight: number,
  |}>,
  +pgaModelCalcClassifications: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>,
  +pgaModelCalculations: ?$ReadOnlyArray<?{|
    +id: string,
    +name: string,
  |}>,
|};
export type PGAModelBuilderCalcTabsGetCalcsQuery = {|
  variables: PGAModelBuilderCalcTabsGetCalcsQueryVariables,
  response: PGAModelBuilderCalcTabsGetCalcsQueryResponse,
|};
*/


/*
query PGAModelBuilderCalcTabsGetCalcsQuery(
  $modelId: ID!
) {
  calcFeaturesForPgaTourModel(modelId: $modelId) {
    id
    name
    calculation {
      id
      name
      classification {
        id
        name
      }
    }
    weight
  }
  pgaModelCalcClassifications {
    id
    name
  }
  pgaModelCalculations {
    id
    name
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "modelId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  (v1/*: any*/),
  (v2/*: any*/)
],
v4 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "modelId",
        "variableName": "modelId"
      }
    ],
    "concreteType": "PGATourModelCalcFeatureType",
    "kind": "LinkedField",
    "name": "calcFeaturesForPgaTourModel",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourModelCalculationType",
        "kind": "LinkedField",
        "name": "calculation",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PGATourModelCalcClassificationType",
            "kind": "LinkedField",
            "name": "classification",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "weight",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourModelCalcClassificationType",
    "kind": "LinkedField",
    "name": "pgaModelCalcClassifications",
    "plural": true,
    "selections": (v3/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PGATourModelCalculationType",
    "kind": "LinkedField",
    "name": "pgaModelCalculations",
    "plural": true,
    "selections": (v3/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PGAModelBuilderCalcTabsGetCalcsQuery",
    "selections": (v4/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PGAModelBuilderCalcTabsGetCalcsQuery",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "3cb9f6694298a6b3c125eda082768f00",
    "id": null,
    "metadata": {},
    "name": "PGAModelBuilderCalcTabsGetCalcsQuery",
    "operationKind": "query",
    "text": "query PGAModelBuilderCalcTabsGetCalcsQuery(\n  $modelId: ID!\n) {\n  calcFeaturesForPgaTourModel(modelId: $modelId) {\n    id\n    name\n    calculation {\n      id\n      name\n      classification {\n        id\n        name\n      }\n    }\n    weight\n  }\n  pgaModelCalcClassifications {\n    id\n    name\n  }\n  pgaModelCalculations {\n    id\n    name\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'acf706ce05e8bf41f615db058e36ca89';

module.exports = node;
